import { render, staticRenderFns } from "./DialogConfirmExportCertificate.vue?vue&type=template&id=2b86b3b8&scoped=true"
import script from "./DialogConfirmExportCertificate.vue?vue&type=script&lang=js"
export * from "./DialogConfirmExportCertificate.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirmExportCertificate.vue?vue&type=style&index=0&id=2b86b3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86b3b8",
  null
  
)

export default component.exports